<template>
    <div class="turndown-reason">
        <label>Miksi päätit hylätä tarjouksen?</label>
        <div class="turndown-reason__dropdown">
            <multiselect
                @select="onSelect"
                :options="turnDownOptions"
                :searchable="true"
                track-by="id"
                label="name"
                :options-limit="15"
                :allow-empty="false"
                placeholder="Valitse"
                selectLabel=""
                deselectLabel=""
                selectedLabel=""
                :show-no-results="false"
                :hide-selected="false"
                :value="selectedOption">
                <span slot="noResult"></span>
            </multiselect>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        model: {
            prop: 'selectedOption',
            event: 'change'
        },
        components: {
            Multiselect
        },
        props: {
            turnDownOptions: {
                type: Array
            },
            selectedOption: {
                type: Object,
                required: false
            }
        },
        methods: {
            onSelect(option) {
                this.$emit('change', option);
            }
        }
    };
</script>
